// extracted by mini-css-extract-plugin
export default {"tabs":"tabs_tabs__3KOgP","tab":"tabs_tab__WD+-8"};